<div [formGroup]="parentForm!">
  <div class="form-group">
    <div *ngIf="data && data.length > 0">
      <div class="table-responsive mb-2">
        <table class="table table-striped table-bordered">
          <thead class="thead-light">
          <tr >

            <th style="text-transform: none">{{ "File Name"|titlecase }}</th>
            <th style="text-transform: none">File Type</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let document of data; let i = index">
            <td>
              <a href="javascript:void(0)" (click)="downloadFile(document.fileId)">
                {{ document.name?.length > 10 ? (document.name | slice:0:20) + '...' : document.name }}
              </a>
            </td>
            <td>{{ document.reportType || 'N/A' | titlecase }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Bind FormArray -->
    <div formArrayName="documentDatas">
      <div *ngFor="let file of documentDatas.controls; let i = index" [formGroupName]="i">
        <div class="card mb-3">
          <div class="card-body p-3">
            <div class="row align-items-center">
              <div class="col-12 text-right">
                <a (click)="removeFile(i)" class="btn btn-link text-danger p-0">
                  <i class="ni ni-fat-remove ni-2x"></i>
                </a>
              </div>
              <div class="col-12 mb-2">
                <label for="docType-{{i}}" class="form-label">Document Type</label>
                <select
                  id="docType-{{i}}"
                  class="form-control"
                  formControlName="docType"
                  [ngClass]="{ 'is-invalid': file.get('docType')?.invalid && (file.get('docType')?.dirty || file.get('docType')?.touched) }"
                  (change)="onDropdownChange(i)">
                  <option *ngFor="let type of documentTypeList" [value]="type.key">{{ type.value }}</option>
                </select>
              </div>
              <div class="col-12">
                <div class="custom-file">
                  <input
                    id="fileInput-{{i}}"
                    class="custom-file-input"
                    type="file"
                    (change)="onFileChange($event, i)"
                    [disabled]="!file.value.docType"
                    [ngClass]="{ 'is-invalid': file.invalid && (file.dirty || file.touched) }"
                    accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.xlsx,.xls,.zip"
                  />
                  <label class="custom-file-label" for="fileInput-{{i}}">
                    {{ (file?.get('file')?.value).name || 'Choose File' }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Add new file -->
    <div class="mt-2">
      <a (click)="addUploadFormControl()" href="javascript:void(0)">
        <i class="fa fa-plus" aria-hidden="true"></i> Additional Upload
      </a>
    </div>
  </div>
</div>
